import { BrowserOptions, Event, EventHint } from '@sentry/react';
import { NetworkError } from 'tg-resources';

// API requests that never got a response (flaky mobile network, navigating
// away mid-request) are not actionable; error responses still get reported.
export const beforeSend = (event: Event, hint: EventHint) =>
    hint.originalException instanceof NetworkError ? null : event;

export const filterOptions: BrowserOptions = {
    // Only report errors thrown from our own bundles. This drops scripts that
    // in-app browsers and Chrome/Google for iOS inject into the page, which
    // report the page URL as their source.
    allowUrls: [/\/assets\/app\//],
    denyUrls: [
        /^chrome-extension:\/\//,
        /^moz-extension:\/\//,
        /^safari-(web-)?extension:\/\//,
        /^webkit-masked-url:\/\//,
        /^iabjs:\/\//,
        /recaptcha/,
    ],
    // Errors from in-app browsers and third-party scripts that carry no
    // stack frames, so allowUrls can't filter them
    ignoreErrors: [
        'Java object is gone',
        '_AutofillCallbackHandler',
        'reCAPTCHA Timeout',
    ],
    beforeSend,
};
